import React from 'react';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkLineSkeleton } from 'uitk-react-skeleton';

const LoadingSkeleton = () => {
  return (
    <div className="loading-skeleton">
      <UitkLayoutFlex space="six" direction="column">
        <UitkLineSkeleton animation type="secondary" />
        <UitkLineSkeleton animation type="secondary" />
        <UitkLineSkeleton animation type="secondary" />
      </UitkLayoutFlex>
    </div>
  );
};

export default LoadingSkeleton;
